<template>
    <a-drawer :title="title"
              :width="windowWidth >= 800 ? 800 : '95%'"
              :visible="visible"
              :bodyStyle="{padding: 0, background: '#f7f7f7'}"
              :zIndex="zIndex"
              placement="right"
              class="hack-switch"
              @close="close">

        <template #extra>
            <a-popconfirm title="确认删除任务？"
                          ok-text="删除"
                          placement="leftTop"
                          cancel-text="取消"
                          @confirm="deleteTask">
                <a-button type="primary"
                          html-type="button"
                          danger
                          class="n-mr-2"
                          v-show="showDelete">删除</a-button>
            </a-popconfirm>

            <a-button type="primary"
                      html-type="button"
                      v-show="!!!canEdit"
                      @click="this.canEdit = true;">编辑</a-button>

            <a-button type="primary"
                      html-type="submit"
                      v-show="!!canEdit"
                      :disabled="checkUpload() || loadings"
                      @click="submit">提交</a-button>
        </template>

        <a-spin :spinning="loadings || detailLoading">
            <a-form name="addTask"
                    ref="form"
                    layout="vertical"
                    class="n-p-4 n-bg-1"
                    :model="addForm">

                <a-row class="n-col-1"
                       wrap
                       :gutter="10">
                    <a-col :sm="12"
                           :xs="24">
                        <h4 class="n-c-base n-f-bold n-mb-3">项目：{{getProjectName()}}</h4>
                    </a-col>

                    <a-col :sm="12"
                           :xs="24"
                           v-if="(parentTaskCache && parentTaskCache.id)||parentTaskName">
                        <h4 class="n-c-base n-f-bold n-mb-3 n-flex"
                            style="cursor: pointer;"
                            @click="viewParnetTask()"
                            :class="{'n-pointer': from == 'projectTask'}">父任务：<i class="n-icon n-icon-link n-icon-size-15"
                               v-if="from == 'projectTask'"></i>{{(parentTaskCache && parentTaskCache.name)||parentTaskName}}</h4>
                    </a-col>
                </a-row>

                <a-row class="n-col-1"
                       wrap
                       :gutter="10">
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="任务标题"
                                     name="title"
                                     :rules="[{ required: true, message: '请输入任务标题' }]">
                            <a-input v-model:value="addForm.title"
                                     placeholder="请输入任务标题"
                                     show-count
                                     :disabled="!!!canEdit"
                                     :class="{'disabledEdit':!!!canEdit}"
                                     :maxlength="255" />
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="分组："
                                     name="group"
                                     :rules="[{ required: true, message: '请选择分组' }]">
                            <a-select v-model:value="addForm.group"
                                      placeholder="请选择分组"
                                      :disabled="!!!canEdit"
                                      :class="{'disabledEdit':!!!canEdit}"
                                      :options="groupOptions" />
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="任务类型"
                                     name="type"
                                     :rules="[{ required: true, message: '请选择任务类型' }]">
                            <a-select v-model:value="addForm.type"
                                      placeholder="请选择任务类型"
                                      :options="typeOptions"
                                      :disabled="!!!canEdit"
                                      :class="{'disabledEdit':!!!canEdit}"
                                      @change="typeChange" />
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="任务标签"
                                     name="tag">
                            <a-select v-model:value="addForm.tag"
                                      placeholder="请选择任务标签"
                                      mode="tags"
                                      @change="tagChange"
                                      :disabled="!!!canEdit"
                                      :class="{'disabledEdit':!!!canEdit}"
                                      :options="tagOptions">

                                <template #option="{ label, color,value }">
                                    <div class="n-flex n-flex-a-c n-flex-a-c n-flex-j-sb">
                                        <div class="n-flex n-flex-a-c n-flex-a-c">
                                            <span class="c-tag n-mr-2"
                                                  :style="{background: color}"></span>
                                            <span>{{label}}</span>
                                        </div>
                                        <span @click="editTag({value, label, color})"
                                              class="n-mr-2">
                                            编辑
                                        </span>
                                    </div>
                                </template>

                                <template #tagRender="{ value, label, closable, onClose }">
                                    <a-tag :closable="closable"
                                           class="n-flex n-flex-a-c"
                                           @close="onClose">
                                        {{ label }}
                                        <i class="c-tag c-tag-small n-ml-1"
                                           :style="{background: tagOptions.filter(item => item.value == value)[0] ? tagOptions.filter(item => item.value == value)[0].color : ''}"></i>
                                    </a-tag>
                                </template>

                                <!-- <template #suffixIcon
                                          v-if="addForm.tag"><span class="c-tag c-tag-small"
                                          :style="{background: tagOptions.filter(item => item.value == addForm.tag)[0] ? tagOptions.filter(item => item.value == addForm.tag)[0].color : ''}"></span></template> -->
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="负责人（至少输入2个字符）"
                                     name="charge">
                            <a-select v-model:value="addForm.charge"
                                      showSearch
                                      placeholder="请选择负责人"
                                      notFoundContent="没有搜索到负责人"
                                      :disabled="!!!canEdit"
                                      :class="{'disabledEdit':!!!canEdit}"
                                      :filterOption="false"
                                      :options="chargeOptions"
                                      :loading="chargeLoading"
                                      @search="searchCharge"
                                      @change="chargeChange">
                                <template #option="{ optionTitle }">
                                    <span>{{ optionTitle }}</span>
                                </template>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="知会人（至少输入2个字符）"
                                     name="notice">
                            <a-select v-model:value="addForm.notice"
                                      showSearch
                                      mode="multiple"
                                      placeholder="请选择知会人"
                                      notFoundContent="没有搜索到知会人"
                                      :disabled="!!!canEdit"
                                      :class="{'disabledEdit':!!!canEdit}"
                                      :filterOption="false"
                                      :options="noticeOptions"
                                      :loading="noticeLoading"
                                      @search="searchNotice"
                                      @change="noticeChange">
                                <template #option="{ optionTitle }">
                                    <span>{{ optionTitle }}</span>
                                </template>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="执行人（至少输入2个字符）"
                                     name="executor">
                            <a-select v-model:value="addForm.executor"
                                      showSearch
                                      mode="multiple"
                                      placeholder="请选择执行人"
                                      notFoundContent="没有搜索到执行人"
                                      :disabled="!!!canEdit"
                                      :class="{'disabledEdit':!!!canEdit}"
                                      :filterOption="false"
                                      :options="executorOptions"
                                      :loading="executorLoading"
                                      @search="searchExecutor"
                                      @change="executorChange">
                                <template #option="{ optionTitle }">
                                    <span>{{ optionTitle }}</span>
                                </template>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="优先级"
                                     name="level">
                            <a-select v-model:value="addForm.level"
                                      placeholder="请选择优先级"
                                      :disabled="!!!canEdit"
                                      :class="{'disabledEdit':!!!canEdit}"
                                      :options="level" />
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="状态"
                                     name="status">
                            <a-select v-model:value="addForm.status"
                                      placeholder="请选择状态"
                                      :disabled="type == 'add' || !!!canEdit"
                                      :class="{'disabledEdit':!!!canEdit}"
                                      :options="status.map(item => {item.disabled = item.value == 0; return item})" />
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="邮件提醒"
                                     name="mail">
                            <a-switch v-model:checked="addForm.mail"
                                      :disabled="!!!canEdit"
                                      :class="{'disabledEdit':!!!canEdit}" />
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="开始日期"
                                     name="start"
                                     :rules="[{ required: true, message: '请选择开始日期'}, {validator: checkDate}]">
                            <a-date-picker value-format="YYYY-MM-DD"
                                           :disabled="!!!canEdit"
                                           :class="{'disabledEdit':!!!canEdit}"
                                           v-model:value="addForm.start"
                                           class="n-col-1" />
                        </a-form-item>
                    </a-col>
                    <a-col :sm="12"
                           :xs="24">
                        <a-form-item label="截止日期"
                                     name="end"
                                     :rules="[{ required: true, message: '请选择截止日期'}, {validator: checkDate }]">
                            <a-date-picker value-format="YYYY-MM-DD"
                                           :disabled="!!!canEdit"
                                           :class="{'disabledEdit':!!!canEdit}"
                                           v-model:value="addForm.end"
                                           class="n-col-1" />
                        </a-form-item>
                    </a-col>

                    <a-col :sm="12"
                           :xs="24"
                           v-for="item in extField"
                           :key="item.id">
                        <a-form-item :label="item.label"
                                     :name="'ext' + item.id">
                            <a-select v-model:value="addForm['ext' + item.id]"
                                      showSearch
                                      :notFoundContent="'没有搜索到' + item.label"
                                      :filterOption="false"
                                      :placeholder="item.placeholder"
                                      :loading="item.loading"
                                      :options="item.options"
                                      :disabled="item.disabled || !!!canEdit"
                                      :class="{'disabledEdit':!!!canEdit}"
                                      @change="item.onChange"
                                      @search="(data) => {this.searchCommon(data, item)}"
                                      v-if="item.type == 'filterSelect'">

                                <template #option="{ optionTitle }">
                                    <span>{{ optionTitle }}</span>
                                </template>
                            </a-select>

                            <a-select v-model:value="addForm['ext' + item.id]"
                                      showSearch
                                      :filterOption="(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0"
                                      :placeholder="item.placeholder"
                                      :options="item.options"
                                      :disabled="item.disabled || !!!canEdit"
                                      :class="{'disabledEdit':!!!canEdit}"
                                      @change="item.onChange"
                                      v-else-if="item.type == 'select'">
                            </a-select>

                            <a-input v-model:value="addForm['ext' + item.id]"
                                     show-count
                                     :placeholder="item.placeholder"
                                     :maxlength="255"
                                     :disabled="!!!canEdit"
                                     :class="{'disabledEdit':!!!canEdit}"
                                     v-else-if="item.type == 'input'" />

                            <a-date-picker value-format="YYYY-MM-DD"
                                           v-model:value="addForm['ext' + item.id]"
                                           class="n-col-1"
                                           :disabled="!!!canEdit"
                                           :class="{'disabledEdit':!!!canEdit}"
                                           v-else-if="item.type == 'date'" />
                        </a-form-item>
                    </a-col>

                    <a-col :span="24">
                        <a-form-item label="任务详情"
                                     name="remark">
                            <QuillEditor :style="{height: '200px'}"
                                         theme="snow"
                                         :readOnly="!!!canEdit"
                                         v-model:content="remark"
                                         toolbar="minimal"
                                         ref="remark"
                                         placeholder="请输入任务详情" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24"
                           class="ant-upload-for-hide">
                        <a-form-item name="fileList"
                                     :extra="canEdit ? '存在未上传成功的附件时，无法提交' : (addForm.fileList.length > 0 ? '' : '未上传任何附件')">
                            <a-upload v-model:file-list="addForm.fileList"
                                      list-type="picture"
                                      class="upload-list-inline"
                                      :disabled="!!!canEdit"
                                      name="files"
                                      :maxCount="4"
                                      :showUploadList="{ showDownloadIcon: true, showRemoveIcon: true, showPreviewIcon:false }"
                                      :headers="{'TOKEN': getToken()}"
                                      :data="{projectId: projectValue}"
                                      :action="HOST + BASE + API.upload"
                                      @change="fileChange"
                                      @download="fileDownload">
                                <a-button v-if="addForm.fileList.length < 4">
                                    <a-row align="middle">
                                        +上传附件
                                    </a-row>
                                </a-button>
                            </a-upload>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>

            <div>
                <a-row class="n-bg-1 n-mt-4 n-plr-4 n-pt-4"
                       v-if="type == 'edit'">
                    <a-col :span="24"
                           class="n-mb-3">
                        <a-table :dataSource="subTask.datas"
                                 :columns="subTask.columns"
                                 :pagination="false"
                                 :loading="subTask.loading"
                                 :bordered="true"
                                 :scroll="{ x: 1000 }"
                                 tableLayout="fixed"
                                 size="small">
                            <template #title>
                                <a-row justify="space-between"
                                       align="middle">
                                    <h4 class="n-m-0">子任务</h4>

                                    <div>
                                        <a-button type="primary"
                                                  size="small"
                                                  class="n-mr-2"
                                                  @click="showLinkTask = true">关联子任务</a-button>

                                        <a-button type="primary"
                                                  size="small"
                                                  @click="$emit('addSubTask',{key: id, title: addForm.title})">新建子任务</a-button>
                                    </div>
                                </a-row>
                            </template>
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key == 'title'">
                                    <a-row>
                                        <a-col class="n-pointer n-e-1"
                                               @click="viewOtherTask(record.id)">{{record.title}}</a-col>
                                    </a-row>
                                </template>

                                <template v-if="column.key == 'level'">
                                    <a-row align="middle"
                                           :gutter="[5]">
                                        <a-col><i class="c-level"
                                               :class="'c-level-' + record.level"></i></a-col>
                                        <a-col>{{ getLevel(record.level).title }}</a-col>
                                    </a-row>
                                </template>

                                <template v-if="column.key == 'status'">
                                    <a-select v-model:value="record.status"
                                              size="small"
                                              class="c-status"
                                              :class="'c-status-' + record.status"
                                              :loading="record.statusLoading"
                                              :options="status.map(item => {item.disabled = item.value == 0; return item})"
                                              @change="updateTaskStatus(record)">
                                    </a-select>
                                </template>

                                <template v-if="column.dataIndex === 'ctrl'">
                                    <a-button size="small"
                                              class="n-mr-2"
                                              type="primary"
                                              @click="deleteSubTask(record)">删除</a-button>
                                </template>
                            </template>
                        </a-table>
                    </a-col>
                </a-row>

                <div class="n-bg-1 n-mt-4 n-p-4">
                    <a-card title="添加动态"
                            size="small"
                            :loading="comment.loading">

                        <!-- <template #extra>
                            <a-radio-group v-model:value="commentType">
                                <a-radio-button value="comment">评论</a-radio-button>
                                <a-radio-button value="process">进展</a-radio-button>
                            </a-radio-group>
                        </template> -->

                        <template #extra>
                            <a-row align="middle"
                                   v-if="type == 'add'">
                                <span class="n-pr-2">{{wetherProcess ? '添加本次任务进展' : '任务暂无进展'}}</span>
                                <a-switch v-model:checked="wetherProcess" />
                            </a-row>
                        </template>

                        <div v-if="type == 'edit' || wetherProcess">
                            <a-row>
                                <a-col :span="24">
                                    <QuillEditor :style="{height: '200px'}"
                                                 theme="snow"
                                                 v-model:content="commentRemark"
                                                 toolbar="minimal"
                                                 ref="comment"
                                                 placeholder="请输入内容" />
                                </a-col>

                                <a-col :span="24"
                                       class="ant-upload-for-hide n-mt-3"
                                       v-if="commentType == 'process'">
                                    <a-upload v-model:file-list="commentFileList"
                                              list-type="picture"
                                              name="files"
                                              class="upload-list-inline"
                                              :maxCount="4"
                                              :showUploadList="{ showDownloadIcon: true, showRemoveIcon: true }"
                                              :headers="{'TOKEN': getToken()}"
                                              :data="{projectId: projectValue}"
                                              :action="HOST + BASE + API.upload"
                                              @change="commontFileChange"
                                              @download="fileDownload">
                                        <a-button v-if="commentFileList.length < 4">
                                            <a-row align="middle">
                                                +上传附件
                                            </a-row>
                                        </a-button>
                                    </a-upload>

                                    <span class="n-c-2 n-mt-2 n-block">存在未上传成功的附件时，无法提交</span>
                                </a-col>
                            </a-row>

                            <a-row class="n-mt-2"
                                   :gutter="[10, 10]">
                                <a-col v-if="type == 'edit'"
                                       :lg="4"
                                       :sm="12"
                                       :span="24">
                                    <a-button type="primary"
                                              class="n-col-1"
                                              :disabled="checkCommentUpload()"
                                              :loading="commentLoading"
                                              @click="submitComment">提交动态</a-button>
                                </a-col>
                                <a-col :lg="type == 'edit' ? 8 : 10"
                                       :sm="12"
                                       :span="24">
                                    <a-input prefix="工时"
                                             suffix="小时"
                                             v-model:value="commentHour" />
                                </a-col>
                                <a-col :lg="type == 'edit' ? 12 : 14"
                                       :span="24">
                                    <a-range-picker v-model:value="commentTimer"
                                                    show-time
                                                    class="n-col-1"
                                                    format="YYYY-MM-DD HH:mm"
                                                    :allowEmpty="[true, true]" />
                                </a-col>
                            </a-row>
                        </div>
                    </a-card>

                    <a-card title="动态"
                            size="small"
                            class="n-mt-4"
                            :loading="comment.loading"
                            v-if="type == 'edit'">
                        <a-list item-layout="horizontal"
                                class="n-col-1 c-list"
                                :dataSource="comment.datas">
                            <template #renderItem="{ item }">
                                <a-list-item>
                                    <a-list-item-meta>
                                        <template #description>
                                            <QuillEditor theme="snow"
                                                         :content="parseContent(item.remark)"
                                                         :readOnly="true"
                                                         toolbar="#hide-toolbar">
                                            </QuillEditor>
                                            <div id="hide-toolbar"
                                                 class="n-hide-none"></div>

                                            <a-upload v-model:file-list="item.progressFileList"
                                                      list-type="picture-card"
                                                      class="n-mt-2"
                                                      :showUploadList="{ showDownloadIcon: true, showRemoveIcon: false, showPreviewIcon:false  }"
                                                      @download="fileDownload">
                                            </a-upload>

                                            <a-row justify="end">
                                                <a-col>
                                                    <div class="n-flex n-flex-a-c">
                                                        <span v-if="item.startTime"
                                                              class="n-flex n-flex-a-c n-mr-3">
                                                            <i class="n-icon n-icon-start n-icon-size-15 n-c-base n-mr-1"></i>{{parseUTCDateTimeForString(item.startTime)}}
                                                        </span>

                                                        <span v-if="item.endTime"
                                                              class="n-flex n-flex-a-c n-mr-3">
                                                            <i class="n-icon n-icon-stop n-icon-size-15 n-c-base n-mr-1"></i>{{parseUTCDateTimeForString(item.endTime)}}
                                                        </span>

                                                        <span class="n-flex n-flex-a-c">
                                                            <i class="n-icon n-icon-time n-icon-size-15 n-c-base n-mr-1"></i>{{item.manHour}}小时
                                                        </span>
                                                    </div>
                                                    <!-- {{item.startTime ? parseUTCDateTimeForString(item.startTime) : ''}}{{item.endTime ? ' ~ ' + parseUTCDateTimeForString(item.endTime) : ''}} 共计【{{item.manHour}}小时】 -->
                                                </a-col>
                                            </a-row>
                                        </template>
                                        <template #title>
                                            <a-row>
                                                <a-col class="n-flex-g">{{item.userName}}</a-col>
                                                <a-col class="n-flex-s n-c-2 n-f-normal">{{parseUTCDateTimeForString(item.submitTime)}}</a-col>
                                            </a-row>
                                        </template>
                                        <template #avatar>
                                            <a-avatar :src="require('@/assets/image/user.png')" />
                                        </template>
                                    </a-list-item-meta>
                                </a-list-item>
                            </template>
                        </a-list>
                    </a-card>
                </div>
            </div>
        </a-spin>
    </a-drawer>

    <LinkTaskBox :visible="showLinkTask"
                 :projectId="projectValue"
                 :parentId="id"
                 ref="linkTaskBox"
                 @close="showLinkTask = false"
                 @success="() => {getSubTask(); $emit('success')}"></LinkTaskBox>

    <a-modal v-model:visible="tagEditVisible"
             title="更新标签"
             :confirm-loading="confirmLoading"
             @ok="handleTagEdit">
        <a-input v-model:value="newTagName"
                 :placeholder="'请输入新Tag名称'"
                 :maxlength="255" />
    </a-modal>
</template>

<script>
    import dayjs from 'dayjs';
    import axios from 'axios'; // 异步请求模块
    import { mapMutations, mapState } from 'vuex';
    import { QuillEditor } from '@vueup/vue-quill'

    import nui from '@/assets/script';

    import LinkTaskBox from '@/components/LinkTaskBox'

    import '@vueup/vue-quill/dist/vue-quill.snow.css';

    export default {
        name: 'AddTaskBox',
        props: {
            title: String,
            visible: { type: Boolean, default: false },
            projectOptions: { type: Array, default: () => [] },
            parentTaskCache: Object,
            projectValue: Number,
            from: String,
            zIndex: Number
        },
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['windowWidth', 'level', 'status'])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                id: null,
                loadings: false,
                detailLoading: false,

                type: 'add',

                showDelete: false,

                chargeLoading: false,
                noticeLoading: false,
                executorLoading: false,
                chargeOptions: [],
                noticeOptions: [],
                executorOptions: [],

                groupOptions: [],
                typeOptions: [],
                tagOptions: [],

                extField: [],


                wetherProcess: false,
                commentFileList: [],
                commentHour: 0,
                commentTimer: null,

                commentLoading: false,
                commentType: 'process',
                commentRemark: {},
                comment: {
                    loading: false,
                    datas: []
                },

                subTask: {
                    loading: false,
                    datas: [],
                    columns: [
                        { title: '项目标题', dataIndex: 'title', key: 'title', width: 250, ellipsis: true },
                        { title: '优先级', dataIndex: 'level', key: 'level', width: 90, ellipsis: true },
                        { title: '状态', dataIndex: 'status', key: 'status', width: 95, ellipsis: true },
                        { title: '创建人', dataIndex: 'creator', key: 'creator', width: 90, ellipsis: true },
                        { title: '负责人', dataIndex: 'charge', key: 'charge', width: 120, ellipsis: true },
                        { title: '执行人', dataIndex: 'executor', key: 'executor', width: 120, ellipsis: true },
                        { title: '开始日期', dataIndex: 'start', key: 'start', width: 90, ellipsis: true },
                        { title: '截止日期', dataIndex: 'end', key: 'end', width: 90, ellipsis: true },
                        { title: '操作', dataIndex: 'ctrl', key: 'ctrl', width: 65, fixed: 'right' }
                    ]
                },

                remark: {},
                addForm: {
                    group: null,
                    title: '',
                    type: null,
                    charge: [],
                    charges: [],
                    notice: [],
                    notices: [],
                    executor: [],
                    executors: [],
                    mail: false,
                    level: null,
                    status: null,
                    start: null,
                    end: null,
                    tag: [],

                    fileList: []
                },

                showLinkTask: false,
                tagEditVisible: false,
                selectTag: {},
                confirmLoading: false,
                newTagName: '',
                parentTaskName: '',
                canEdit: false
            })
        },
        watch: {
            visible: function () {
                // 避免外部添加数据，每次打开都重新获取一下
                if (this.visible) {
                    this.reset()
                    this.addForm.status = 1;
                    this.getData()
                }
            },
            canEdit: function () {
                this.$refs.remark && this.$refs.remark.getQuill().enable(this.canEdit)
            },
            commentHour: function (val, preVal) {
                const reg = /^-?\d*(\.\d*)?$/;

                if (!isNaN(+val) && reg.test(val) || val === '' || val === '-') {
                    this.commentHour = val;
                } else {
                    this.commentHour = preVal;
                }
            }
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setWindowSize'])),

            tagChange () {
            },

            NMounted () {
            },
            getDetail (id, canEdit) {
                var cacheId = id || this.id;

                if (canEdit != undefined) {
                    this.canEdit = canEdit
                }

                this.type = 'edit'
                this.id = cacheId;
                this.parentTaskName = "";

                this.detailLoading = true;

                this.request(this.API.taskDetail, {
                    params: { taskId: this.id }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        var data = res.data;

                        this.extField = this.parseField(this, data.fieldList, true);
                        this.noticeOptions = data.informList.map(item => {
                            return {
                                value: item.adName,
                                label: item.userName,
                                optionTitle: item.userName + ' ' + item.position,
                                ext: item,
                            }
                        });
                        this.chargeOptions = data.principalList.map(item => {
                            return {
                                value: item.adName,
                                label: item.userName,
                                optionTitle: item.userName + ' ' + item.position,
                                ext: item,
                            }
                        });
                        this.executorOptions = data.executorList.map(item => {
                            return {
                                value: item.adName,
                                label: item.userName,
                                optionTitle: item.userName + ' ' + item.position,
                                ext: item,
                            }
                        });

                        this.showDelete = !data.subTaskList || data.subTaskList.length <= 0

                        this.addForm = {
                            group: data.groupId,
                            groupName: data.groupName,
                            title: data.taskName,
                            type: data.taskTypeId,
                            charge: data.principalList.map(item => item.adName),
                            charges: data.principalList,
                            notice: data.informList.map(item => item.adName),
                            notices: data.informList,
                            executor: data.executorList.map(item => item.adName),
                            executors: data.executorList,
                            mail: data.isMail == 1,
                            level: data.priority,
                            status: data.status,
                            start: this.parseUTC(data.startTime),
                            end: this.parseUTC(data.endTime),
                            tag: data.labelIdList || [],
                            parentId: data.parentId,
                            fileList: data.taskfileList.map(item => {
                                return {
                                    ext: { fileName: item.fileName, filePath: item.filePath },
                                    name: item.fileName,
                                    thumbUrl: '',
                                    uid: item.taskFileId,
                                    status: 'done'
                                }
                            })
                        }

                        // 为ITBP赋值
                        var ITBP = data.fieldList.filter(item => item.fieldName == 'ITBP')[0];

                        if (ITBP && ITBP.fieldValue) {
                            var ITBPField = this.extField.filter(item => item.id == ITBP.fieldId)[0],
                                userId = ITBP.fieldValue.split(this.SPLIT)[0];

                            this.request(this.SSO_HOST + this.API.getUserInfoByUserId, {
                                method: 'post',
                                data: {
                                    val: userId
                                }
                            }).then(res => {
                                if (res.code == this.REQUEST_SUCCESS_CODE_2) {
                                    ITBPField.options = [{ label: res.data.name, value: userId, optionTitle: res.data.name + ' ' + res.data.externalTitles }]
                                }
                            })
                        }

                        try {
                            this.remark = JSON.parse(data.remark)
                        } catch {
                            this.remark = (typeof data.remark).toLowerCase() == 'string' ? { ops: [{ insert: data.remark }] } : {};
                        }

                        this.$refs.remark.getQuill().setContents(this.remark)

                        data.fieldList.forEach(item => {
                            this.addForm['ext' + item.fieldId] = item.fieldValue ? (item.fieldValue.indexOf(this.SPLIT) >= 0 ? item.fieldValue.split(this.SPLIT)[0] : item.fieldValue) : null;
                        })

                        if (data.parentId) {
                            this.request(this.API.taskDetail, {
                                params: { taskId: data.parentId }
                            }).then(parentRes => {
                                if (parentRes.code == this.REQUEST_SUCCESS_CODE) {
                                    this.parentTaskName = parentRes.data.taskName;
                                }
                            });
                        }

                        this.detailLoading = false;
                    } else {
                        this.error(res.msg)
                    }
                })

                this.getSubTask()
                this.getComment()
            },
            /**
             * @description 获取评论列表
             */
            getComment () {
                this.comment.loading = true

                this.request(this.API.comment, {
                    method: 'post',
                    params: { taskId: this.id }
                }).then(res => {
                    // res = { "code": "0", "msg": "操作成功", "data": [{ "userName": "徐小亮", "createTime": "2022-07-30T01:51:39.000+00:00", "content": "bgfbgfbb", "fileList": [] }, { "userName": "徐小亮", "createTime": "2022-07-30T01:51:29.000+00:00", "content": "gfgfb", "fileList": null }, { "userName": "徐小亮", "createTime": "2022-07-22T10:45:37.000+00:00", "content": "反对敢死队风格士大夫", "fileList": null }, { "userName": "徐小亮", "createTime": "2022-07-22T10:17:19.000+00:00", "content": "ssss", "fileList": [] }] }
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.comment.datas = res.data.map(item => {
                            item.progressFileList && (item.progressFileList = item.progressFileList.map((item, index) => {
                                return {
                                    ext: { fileName: item.fileName, filePath: item.filePath },
                                    name: item.fileName,
                                    thumbUrl: '',
                                    uid: index,
                                    status: 'done'
                                }
                            }))

                            return item
                        });
                    } else {
                        this.error(res.msg);
                    }

                    this.comment.loading = false
                })
            },
            getSubTask () {
                this.subTask.loading = true

                this.request(this.API.subTask, {
                    method: 'post',
                    data: { taskId: this.id }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.subTask.datas = this.formatTaskData(res.data, false)
                    } else {
                        this.error(res.msg);
                    }

                    this.subTask.loading = false
                })
            },
            viewParnetTask () {
                var parentTaskId = (this.parentTaskCache && this.parentTaskCache.id) || this.addForm.parentId;

                if (parentTaskId) {
                    this.$emit("viewOtherTask", parentTaskId)
                }
            },
            viewOtherTask (taskId) {
                this.$emit("viewOtherTask", taskId)
            },
            editTag (taginfo) {
                this.tagEditVisible = true;
                this.selectTag = taginfo;
                this.newTagName = taginfo.label;
            },
            handleTagEdit () {
                this.request(this.API.updateTag, {
                    method: 'post',
                    params: { id: this.selectTag.value, name: this.newTagName }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.request(this.API.tag, { method: 'post', params: { projectId: this.projectValue } }).then((res) => {
                            this.tagOptions = res.data.map(item => {
                                return {
                                    value: item.id,
                                    label: item.name,
                                    color: item.colorCode
                                }
                            })
                        });
                    } else {
                        this.error(res.msg)
                    }
                    // 更新删除子任务刷新父页面
                    // 保存任务刷新父页面
                });
                this.tagEditVisible = false;
            },
            /**
             * @description 更新任务状态
             */
            updateTaskStatus (data) {
                data.statusLoading = true;

                this.request(this.API.updateTaskStatus, {
                    method: 'post',
                    data: { taskId: data.key, status: this.subTask.datas.filter(item => item.key == data.key)[0].status }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.success('更新状态成功')
                        this.$emit('success')
                        data.statusLoading = false;
                    } else {
                        this.error(res.msg)
                    }
                })
            },
            checkDate (rules, value, callback) {
                var start = this.addForm.start,
                    end = this.addForm.end;


                if (start && end && new Date(start).getTime() > new Date(end).getTime()) {
                    callback('开始日期不能大于截止日期')
                    return
                }

                callback()
            },
            /**
             * @description 解除关联
             */
            deleteSubTask (data) {
                this.subTask.loading = true

                this.request(this.API.toggleSubTask, {
                    method: 'post',
                    data: { subTaskIdList: [data.id] }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.success('解除关联成功')
                        this.$emit('success')
                        this.getSubTask()
                    } else {
                        this.error(res.msg)
                    }
                    // 更新删除子任务刷新父页面
                    // 保存任务刷新父页面
                })

            },
            /**
             * @description 获取添加需要的数据
             */
            getData () {
                this.loadings = true;

                var dataPromise = [
                    this.request(this.API.getGroup, { method: 'post', data: { projectId: this.projectValue } }),
                    this.request(this.API.getTaskTypeByProject, { method: 'post', data: { projectId: this.projectValue } }),
                    this.request(this.API.tag, { method: 'post', params: { projectId: this.projectValue } }),
                ];

                Promise.all(dataPromise).then(res => {
                    if (res[0].code == this.REQUEST_SUCCESS_CODE) {
                        this.groupOptions = res[0].data.map(item => {
                            return {
                                value: item.groupId,
                                label: item.groupName
                            }
                        })

                        this.groupOptions[0] && !this.addForm.group && (this.addForm.group = this.groupOptions[0].value)
                    }

                    if (res[1].code == this.REQUEST_SUCCESS_CODE) {
                        this.typeOptions = res[1].data.map(item => {
                            return {
                                value: item.id,
                                label: item.taskTypeName
                            }
                        })

                        if (!this.addForm.type) {
                            // var defaultType = this.typeOptions.filter(item => item.value == 90)[0]

                            // if (defaultType) {
                            //     this.addForm.type = defaultType.value
                            // } else if (this.typeOptions[0]) {
                            this.addForm.type = this.typeOptions[0].value
                            // }

                            this.typeChange()
                        }
                    }

                    if (res[2].code == this.REQUEST_SUCCESS_CODE) {
                        this.tagOptions = res[2].data.map(item => {
                            return {
                                value: item.id,
                                label: item.name,
                                color: item.colorCode
                            }
                        })
                    }

                    this.loadings = false;
                })
            },
            /**
             * @description 搜索负责人
             */
            searchCharge (data) {
                if (data.length < 2) {
                    return
                }

                this.searchUser(data, 'charge')
            },
            /**
             * @description 搜索知会人
             */
            searchNotice (data) {
                if (data.length < 2) {
                    return
                }

                this.searchUser(data, 'notice')
            },
            /**
             * @description 搜索负责人
             */
            searchExecutor (data) {
                if (data.length < 2) {
                    return
                }

                this.searchUser(data, 'executor')
            },
            /**
             * @description 搜索用户
             */
            searchUser (data, type) {
                this[type + 'Loading'] = true;

                this.request(this.API.getUserListByAddition, {
                    params: {
                        username: data
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this[type + 'Options'] = res.data.map(item => {
                            return {
                                value: item.adName,
                                label: item.userName,
                                optionTitle: item.userName + ' ' + item.position,
                                ext: item,
                            }
                        })

                        this[type + 'Loading'] = false;
                    }
                })
            },
            parseContent (str) {
                try {
                    return JSON.parse(str)
                } catch (e) {
                    return str
                }
            },
            /**
             * @description 缓存多选数据
             */
            chargeChange (value) {
                var data = this.chargeOptions.filter(item => item.value == value)[0] || {};

                this.addForm.charges = [data.ext]
            },
            /**
             * @description 缓存多选数据
             */
            noticeChange (data, options) {
                var data = options.filter(item => data.indexOf(item.value) >= 0);

                this.addForm.notices = data.map(item => item.ext)
            },
            /**
             * @description 缓存多选数据
             */
            executorChange (data, options) {
                var data = options.filter(item => data.indexOf(item.value) >= 0);

                this.addForm.executors = data.map(item => item.ext)
            },
            /**
             * @description 计算项目名称
             */
            getProjectName () {
                var project = this.projectOptions.filter(item => item.value == this.projectValue)[0];

                return project ? project.label : '-'
            },
            /**
             * @description 检查文件上传状态
             */
            checkUpload () {
                return this.addForm.fileList.filter(item => item.status != 'done').length > 0
            },
            checkCommentUpload () {
                return this.commentFileList.filter(item => item.status != 'done').length > 0
            },
            /**
             * @description 上传文件
             */
            fileChange (data) {
                if (data.file.status == 'removed') {
                    return
                }
                if (data.file.percent == 100 && data.file.status != 'uploading') {
                    if (data.file.response.code == this.REQUEST_SUCCESS_CODE) {
                        this.addForm.fileList = this.addForm.fileList.map(item => {
                            if (item.uid == data.file.uid) {
                                item.ext = data.file.response.data[0];
                            }
                            return item
                        })
                    } else {
                        this.error(data.file.response.msg)

                        this.addForm.fileList = this.addForm.fileList.map(item => {
                            if (item.uid == data.file.uid) {
                                item.status = 'error'
                            }

                            return item
                        })
                    }
                }
            },
            commontFileChange (data) {
                if (data.file.status == 'removed') {
                    return
                }

                if (data.file.percent == 100 && data.file.status != 'uploading') {
                    if (data.file.response.code == this.REQUEST_SUCCESS_CODE) {
                        this.commentFileList = this.commentFileList.map(item => {
                            if (item.uid == data.file.uid) {
                                item.ext = data.file.response.data[0];
                            }
                            return item
                        })
                    } else {
                        this.error(data.file.response.msg)

                        this.commentFileList = this.commentFileList.map(item => {
                            if (item.uid == data.file.uid) {
                                item.status = 'error'
                            }

                            return item
                        })
                    }
                }
            },
            /**
             * @description 下载文件
             */
            fileDownload (data) {
                axios({
                    url: this.HOST + this.BASE + this.API.download,
                    method: 'post',
                    responseType: 'blob',
                    headers: { TOKEN: this.getToken() },
                    data: {
                        fileName: data.ext.fileName,
                        filePath: data.ext.filePath
                    }
                }).then(res => {
                    let binaryData = [res.data],
                        a = document.createElement("a");

                    a.href = window.URL.createObjectURL(new Blob(binaryData));
                    a.download = data.ext.fileName;
                    a.click();
                    window.URL.revokeObjectURL(a.href);
                })
            },
            /**
             * @description 删除任务
             */
            deleteTask () {
                this.detailLoading = true;

                this.request(this.API.deleteTask, {
                    method: 'post',
                    params: { taskId: this.id }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.success('删除成功')
                        this.$emit('delete')
                        this.$emit('close')
                    } else {
                        this.error(res.msg)
                    }

                    this.detailLoading = false;
                })
            },
            /**
             * @description 选择类型获取字段
             */
            typeChange () {
                this.request(this.API.getTaskType, {
                    params: {
                        taskTypeId: this.addForm.type
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        res.data.fieldList.forEach(item => {
                            !this.addForm['ext' + item.fieldId] && (this.addForm['ext' + item.fieldId] = null)
                        })

                        this.$nextTick(() => {
                            this.extField = this.parseField(this, res.data.fieldList)
                        })
                    }
                })
            },
            close () {
                this.reset()
                this.$emit('close')
            },
            reset () {
                this.chargeOptions = [];
                this.noticeOptions = [];
                this.executorOptions = [];
                this.extField = [];
                this.showDelete = false;

                this.addForm = {
                    group: null,
                    title: '',
                    type: null,
                    charge: [],
                    notice: [],
                    executor: [],
                    charges: [],
                    notices: [],
                    executors: [],
                    mail: false,
                    level: null,
                    status: null,
                    start: null,
                    end: null,
                    tag: [],
                    fileList: []
                }

                this.remark = {};
                this.id = null;
                this.type = 'add'
                this.subTask.datas = []
                this.canEdit = true

                this.commentRemark = {}
                this.commentHour = 0;
                this.commentFileList = [];

                this.$refs.remark && this.$refs.remark.getQuill().setContents({})
                this.$refs.commentRemark && this.$refs.commentRemark.getQuill().setContents({})
                this.$refs.form && this.$refs.form.resetFields()
            },
            /**
            * @description 搜索用户
            */
            searchCommon (data, record) {
                record.loading = true;

                var params = record.params || {};

                record.keywordKey && (params[record.keywordKey] = data)

                this.request(record.url, {
                    params
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        record.options = res.data.map(item => {
                            return {
                                value: item[record.valueKey],
                                label: item[record.labelKey],
                                optionTitle: record.optionTitle.map(oItem => item[oItem]).join(' '),
                                ext: item,
                            }
                        })

                        record.loading = false;
                    }
                })
            },
            submitComment () {

                if (this.commentHour <= 0 && this.editorNull(this.commentRemark) && this.commentFileList.length <= 0) {
                    this.error('请至少填写：工时、动态信息、附件的一项');
                    return
                }

                this.commentLoading = true;

                this.request(this.commentType == 'comment' ? this.API.addCommentComment : this.API.addProcessComment, {
                    method: 'post',
                    data: {
                        taskId: this.id,
                        manHour: this.commentHour,
                        comment: this.commentType == 'comment' ? JSON.stringify(this.commentRemark) : undefined,
                        remark: this.commentType != 'comment' ? JSON.stringify(this.commentRemark) : undefined,
                        fileList: this.commentType != 'comment' ? this.commentFileList.map(item => item.ext) : undefined,
                        startTime: this.commentTimer && this.commentTimer[0] ? dayjs(this.commentTimer[0]).toISOString() : null,
                        endTime: this.commentTimer && this.commentTimer[1] ? dayjs(this.commentTimer[1]).toISOString() : null
                    }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.success('添加成功')
                        this.$emit('success')
                        this.commentRemark = {}
                        this.commentHour = 0;
                        this.commentTimer = null
                        this.commentFileList = [];
                        this.getComment()
                    } else {
                        this.error(res.msg);
                    }

                    this.commentLoading = false;
                }).catch(err => {
                    this.commentLoading = false;
                })
            },
            submit () {
                this.$refs.form.validate().then(res => {
                    if (this.type == 'add' && this.wetherProcess) {
                        if (this.commentHour <= 0 && this.editorNull(this.commentRemark) && this.commentFileList.length <= 0) {
                            this.error('请至少填写：工时、动态信息、附件的一项');
                            return
                        }
                    }

                    this.loadings = true;

                    this.request(this.type == 'add' ? this.API.addTask : this.API.editTask, {
                        method: 'post',
                        data: {
                            id: this.type == 'add' ? undefined : this.id,
                            projectId: this.projectValue,
                            groupId: this.addForm.group,
                            taskName: this.addForm.title,
                            taskTypeId: this.addForm.type,
                            principalList: this.addForm.charges,
                            informList: this.addForm.notices,
                            executorList: this.addForm.executors,
                            priority: this.addForm.level,
                            labelIdList: this.addForm.tag,
                            status: this.addForm.status,
                            startTime: this.addForm.start,
                            endTime: this.addForm.end,
                            isMail: this.addForm.mail ? 1 : 0,
                            remark: JSON.stringify(this.remark),
                            parentId: this.parentTaskCache ? this.parentTaskCache.id : undefined,
                            taskFileList: this.addForm.fileList.map(item => item.ext),
                            fieldList: this.extField.map(item => {
                                return {
                                    fieldId: item.id,
                                    fileValue: this.parseExt(item)
                                }
                            }),
                            processList: this.type == 'add' && this.wetherProcess ? [{
                                content: JSON.stringify(this.commentRemark),
                                fileList: this.commentFileList.map(item => item.ext),
                                startTime: this.commentTimer[0] ? dayjs(this.commentTimer[0]).toISOString() : null,
                                endTime: this.commentTimer[1] ? dayjs(this.commentTimer[1]).toISOString() : null,
                                manHour: this.commentHour
                            }] : undefined,
                        }
                    }).then(res => {
                        if (res.code == this.REQUEST_SUCCESS_CODE) {
                            this.success((this.type == 'add' ? '添加' : '编辑') + '任务成功')
                            this.reset()
                            this.$emit('success')
                            this.$emit('close')
                        } else {
                            this.error(res.msg);
                        }

                        this.loadings = false;
                    }).catch(err => {
                        this.loadings = false;
                    })
                })
            },
            parseExt (data) {
                var value = this.addForm['ext' + data.id];

                if (value) {
                    if (data.type == 'select' || data.type == 'filterSelect') {
                        var text = data.options.filter(oItem => oItem.value == this.addForm['ext' + data.id])[0];

                        return value + (text ? this.SPLIT + text.label : '')
                    } else {
                        return value
                    }
                } else {
                    return ''
                }
            }
        }),
        components: {
            LinkTaskBox,
            QuillEditor
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss">
    .c-list .ql-container.ql-snow {
        border: 0;

        .ql-editor {
            padding: 0;
        }
    }

    .disabledEdit {
        border: none !important;
        background-color: rgba(233, 233, 233, 0.3) !important;

        & input:disabled {
            color: #000;
            opacity: 1;
            -webkit-text-fill-color: #000;
        }

        &
            .ant-select-disabled.ant-select:not(.ant-select-customize-input)
            .ant-select-selector {
            color: #000 !important;
            opacity: 1 !important;
            -webkit-text-fill-color: #000 !important;
        }

        & .ant-input-show-count-suffix {
            display: none !important;
        }

        & .ant-select-selector {
            border: none !important;
            background-color: rgba(233, 233, 233, 0.3) !important;
        }

        & .ant-select-arrow {
            display: none !important;
        }

        & .ant-select-selection-item {
            color: #000 !important;
        }

        & .ant-picker-suffix {
            display: none !important;
        }

        & .ant-form-item-control {
            border: none !important;
            background-color: rgba(233, 233, 233, 0.3) !important;
        }
    }
</style>